export default __webpack_public_path__ + "static/media/Scale.20d6dd48.svg";